"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromAttrDTO = void 0;
const any_js_1 = require("./any.js");
const anyOf_js_1 = require("./anyOf.js");
const list_js_1 = require("./list.js");
const map_js_1 = require("./map.js");
const primitive_js_1 = require("./primitive.js");
const record_js_1 = require("./record.js");
const set_js_1 = require("./set.js");
const fromAttrDTO = (attrDTO) => {
    switch (attrDTO.type) {
        case 'any':
            return (0, any_js_1.fromJSONAnyAttr)(attrDTO);
        case 'null':
        case 'boolean':
        case 'number':
        case 'string':
        case 'binary':
            return (0, primitive_js_1.fromJSONPrimitiveAttr)(attrDTO);
        case 'set':
            return (0, set_js_1.fromJSONSetAttr)(attrDTO);
        case 'list':
            return (0, list_js_1.fromListAttrDTO)(attrDTO);
        case 'map':
            return (0, map_js_1.fromJSONMapAttr)(attrDTO);
        case 'record':
            return (0, record_js_1.fromJSONRecordAttr)(attrDTO);
        case 'anyOf':
            return (0, anyOf_js_1.fromJSONAnyOfAttr)(attrDTO);
    }
};
exports.fromAttrDTO = fromAttrDTO;
